import {useState} from 'react';

import {makeGetTeaForm} from 'main/factories/usecases';
import {OperationStateTypesEnum} from 'presentation/constants';

import {useEmbeddedInfoStore} from 'presentation/modules/booking/shared/store/useEmbeddedInfoStore';

export function useTeaForm() {
	const [isFetchingUrl, setIsFetchingUrl] = useState(OperationStateTypesEnum.NONE);

	const openEmbeddedInfo = useEmbeddedInfoStore(state => state.openEmbeddedInfo);
	const setOpenEmbeddedInfo = useEmbeddedInfoStore(state => state.setOpenEmbeddedInfo);
	const [embeddedLink, setEmbeddedLink] = useState('');
	const [openIFrame, setOpenIFrame] = useState(false);

	const IS_FETCHING = isFetchingUrl === OperationStateTypesEnum.PENDING;

	const handleOpenEmbeddedInfo = () => {
		setOpenEmbeddedInfo(true);
	};

	const handleCloseEmbeddedInfo = () => {
		setOpenEmbeddedInfo(false);
	};

	const handleOpenIframe = () => {
		setOpenIFrame(true);
	};

	const handleCloseIframe = () => {
		setOpenIFrame(false);
	};

	const getTeaFormUrl = async () => {
		if (isFetchingUrl === OperationStateTypesEnum.PENDING) {
			return;
		}
		try {
			setIsFetchingUrl(OperationStateTypesEnum.PENDING);
			const response = await makeGetTeaForm().get();
			setIsFetchingUrl(OperationStateTypesEnum.DONE);
			setEmbeddedLink(response.url);
			handleCloseEmbeddedInfo();
			handleOpenIframe();
		} catch (error) {
			setIsFetchingUrl(OperationStateTypesEnum.ERROR);
		}
	};

	return {
		getTeaFormUrl,
		isFetchingUrl,
		handleCloseEmbeddedInfo,
		handleOpenEmbeddedInfo,
		openEmbeddedInfo,
		embeddedLink,
		IS_FETCHING,
		openIFrame,
		handleOpenIframe,
		handleCloseIframe,
	};
}
